import React, { useState } from 'react';
import { StudentDirectoryTable } from './StudentDirectoryTable';
import { PrincipalDirectoryTable } from './PrincipalDirectoryTable';
import { StudentReportCardModal } from './StudentReportCardModal';
import { PrincipalReportCardModal } from './PrincipalReportCardModal';

export const ReportCardTab = ({ onOpenQuestionPaper }) => {
  const [viewMode, setViewMode] = useState('student'); // 'student' | 'principal'
  
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const handleStudentClick = (student) => {
    setSelectedStudent(student);
  };

  const handleBranchClick = (branch) => {
    setSelectedBranch(branch);
  };

  return (
    <section id="report-card" className="section-content">
      {/* Section Header with View Toggle */}
      <div className="section-header flex justify-between items-center flex-wrap gap-4 mb-6">
        <div>
          <h2 className="text-3xl font-bold text-gray-800" id="report-card-title">
            Report Card
          </h2>
          <p className="text-sm text-gray-600 mt-1" id="report-card-subtitle">
            {viewMode === 'student'
              ? 'Comprehensive performance analysis for individual student'
              : 'School-wide performance summary for principals & school leadership'}
          </p>
        </div>

        {/* Toggle Button Container */}
        <div className="flex bg-gray-200 p-1 rounded-xl shadow-inner border border-gray-300 select-none">
          <button
            onClick={() => setViewMode('student')}
            className={`px-4 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer ${
              viewMode === 'student'
                ? 'bg-[#347363] text-white shadow'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Student Report Card
          </button>
          <button
            onClick={() => setViewMode('principal')}
            className={`px-4 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer ${
              viewMode === 'principal'
                ? 'bg-[#347363] text-white shadow'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Principal Report Card
          </button>
        </div>
      </div>

      {/* Dynamic Views */}
      {viewMode === 'student' ? (
        <StudentDirectoryTable onStudentClick={handleStudentClick} />
      ) : (
        <PrincipalDirectoryTable onBranchClick={handleBranchClick} />
      )}

      {/* Student Report Overlay Modal */}
      {selectedStudent && (
        <StudentReportCardModal
          student={selectedStudent}
          onClose={() => setSelectedStudent(null)}
          onOpenQuestionPaper={onOpenQuestionPaper}
        />
      )}

      {/* Principal Report Overlay Modal */}
      {selectedBranch && (
        <PrincipalReportCardModal
          branchName={selectedBranch}
          onClose={() => setSelectedBranch(null)}
        />
      )}
    </section>
  );
};
export default ReportCardTab;
